import { BASIC_COMPONENTS } from './components/';
import { BASIC_DIRECTIVES } from './directives/';

import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PipesModule } from './pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMyDatePickerModule } from '@nodro7/angular-mydatepicker';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        PipesModule,
        TranslateModule,
        NgMultiSelectDropDownModule,
        QRCodeModule,
        AngularMyDatePickerModule,
    ],
    declarations: [BASIC_COMPONENTS, BASIC_DIRECTIVES],
    exports: [
        BASIC_COMPONENTS,
        BASIC_DIRECTIVES,
        PipesModule,
        CommonModule,
        RouterModule,
        FormsModule,
        PipesModule,
        QRCodeModule,
        AngularMyDatePickerModule,
    ],
})
export class LibModule {}
